import styled from 'styled-components';

export const Outline = styled.path`
  color: ${({ theme }) => theme.colors.primary};
`;

export const Marks = styled.path`
  color: ${({ theme }) => theme.colors.accent};
`;
